import { useFade } from '../hooks/useFade';

export default function FadeIn({ children, delay = 0, style = {} }) {
  const ref = useFade();
  return (
    <div
      ref={ref}
      className="fi"
      style={{ transitionDelay: `${delay}ms`, ...style }}
    >
      {children}
    </div>
  );
}
